export enum BroadcastSubTypeEnum {
    PROGRAM = 'PROGRAM',
    ADVERTISEMENT = 'ADVERTISEMENT',
}
